import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import api from '../utils/api';
import { StandingsTabs } from '../Standings';
import DraftCard from './DraftCard';
import MatchupsCard from './MatchupsCard';
import './Home.css';

// Current standings at a glance; hides itself if there is nothing to show.
const StandingsCard = () => {
    const [data, updateData] = useState(null);

    useEffect(() => {
        api.get('/api/v1/standings')
            .then(({ data }) => updateData(data))
            .catch(() => updateData(null));
    }, []);

    if (!data || data.week === null) {
        return null;
    }
    return (
        <div className="home-card">
            <div className="d-flex justify-content-between align-items-baseline mb-2">
                <h5 className="mb-0">Standings</h5>
                <span className="text-light opacity-75 small">After Week {data.week}</span>
            </div>
            <StandingsTabs data={data} />
            <NavLink to="/standings" className="small">
                Full standings page <i className="bi bi-chevron-right"></i>
            </NavLink>
        </div>
    );
};

const Home = ({ userData, outgoingPicks }) => (
    <div id='homeContainer' className="d-flex flex-column align-items-center">
        <div className="home-header">
            <h1 className="home-header-title">Underwhelming Gents</h1>
            <p className="home-header-subtitle">Fantasy Football League &middot; Est. 2017</p>
        </div>
        <MatchupsCard userData={userData} />
        <StandingsCard />
        <DraftCard outgoingPicks={outgoingPicks} />
    </div>
);

export default Home;
